import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Button,
  Spin,
  Col,
  Modal,
  Row,
  Input,
  Typography,
} from 'antd';
import FormSubmitControls from 'components/FormSubmitControls';
import { postPlaca } from 'api/recaudacion/placas';
import { getVehiculo, patchVehiculo } from 'api/recaudacion/vehiculos';
import { getMotocicleta, patchMotocicleta } from 'api/recaudacion/motocicletas';
import { getRemolque, patchRemolque } from 'api/recaudacion/remolque';

const patchVehiculosMap = {
  4: patchVehiculo,
  16: patchMotocicleta,
  17: patchRemolque,
};

const retrieversPadronesMap = {
  4: getVehiculo,
  16: getMotocicleta,
  17: getRemolque,
};

export const saveOrLinkPlaca = async (
  _values,
  tipoDePadronVehicular,
  vehiculo,
  setLoading,
  callback,
  _placa,
) => {
  if (setLoading) {
    setLoading(true);
  }
  const values = {
    numero_de_placa: _values.numero_de_placa,
    vigente: 'vigente' in _values ? _values.vigente : true,
  };
  const fkByTipoDePadron = {
    4: 'vehiculo',
    16: 'motocicleta',
    17: 'remolque',
  };
  if (vehiculo.contribuyente_propietario) {
    values.contribuyente_propietario = vehiculo.contribuyente_propietario?.id
    || vehiculo.contribuyente_propietario;
  } else {
    const ciudadano = vehiculo.propietario || vehiculo.ciudadano_propietario;
    values.ciudadano = ciudadano?.id || ciudadano;
  }
  values[fkByTipoDePadron[tipoDePadronVehicular]] = vehiculo.id;
  const placa = _placa || await postPlaca(values);
  if (placa) {
    const vehiculoNeedsPlaca = vehiculo.estatus_del_vehiculo === 1
    || vehiculo.estatus_del_vehiculo === 2;
    const vehiculoHasPlaca = !!vehiculo[tipoDePadronVehicular === 17
      ? 'placa' : 'numero_de_placa_vigente'];
    const updated = !vehiculoNeedsPlaca || (vehiculoNeedsPlaca && vehiculoHasPlaca)
      || await patchVehiculosMap[tipoDePadronVehicular](
        vehiculo.id,
        {
          [tipoDePadronVehicular === 17
            ? 'placa' : 'numero_de_placa_vigente']: placa.numero_de_placa,
        },
      );
    if (updated) {
      if (callback) {
        await callback(vehiculo, placa);
      }
      if (setLoading) {
        setLoading(false);
      }
      return true;
    }
    if (setLoading) {
      setLoading(false);
    }
    return false;
  }
  if (setLoading) {
    setLoading(false);
  }
  return false;
};

const WidgetPlaca = ({
  visible,
  setVisible,
  vehiculoId,
  padronVehicular,
  callback,
  message,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [vehiculo, setDataVehiculo] = useState([]);

  useEffect(() => {
    if (vehiculoId) {
      const fetch = async () => {
        setLoading(true);
        const _vehiculo = await retrieversPadronesMap[padronVehicular](vehiculoId);
        if (_vehiculo) {
          setDataVehiculo(_vehiculo);
          const numero_de_placa = _vehiculo[padronVehicular === 17
            ? 'placa' : 'numero_de_placa_vigente'];
          form.setFieldsValue({ numero_de_placa });
        }
        setLoading(false);
      };
      fetch();
    }
  }, [visible]);

  const onCancel = () => {
    form.resetFields();
    setVisible(false);
  };
  return (
    <Modal
      visible={visible}
      closable={false}
      footer={null}
      title={(
        <FormSubmitControls
          label="Agregar Placa"
          onFinish={form.submit}
          onCancel={onCancel}
          loading={loading}
        />
      )}
      keyboard={!loading}
      maskClosable={!loading}
      onCancel={onCancel}
      forceRender
    >
      <Spin tip="Cargando..." spinning={loading}>
        <Col span={24}>
          <Form
            form={form}
            layout="vertical"
            onFinish={(values) => saveOrLinkPlaca(
              values,
              padronVehicular,
              vehiculo,
              setLoading,
              async (_vehiculo, _placa) => {
                await callback(_vehiculo, _placa);
                onCancel();
              },
            )}
          >
            <Row gutter={10}>
              <Col span={24}>
                <Form.Item
                  name="numero_de_placa"
                  label="Número de Placa"
                  rules={[{ required: true }]}
                >
                  <Input
                    disabled={loading}
                    // || vehiculo[padronVehicular === 17 ? 'placa' : 'numero_de_placa_vigente']}
                    maxLength={10}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col>
                <Typography.Text>
                  {message}
                </Typography.Text>
              </Col>
            </Row>
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Form>
        </Col>
      </Spin>
    </Modal>
  );
};

WidgetPlaca.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  vehiculoId: PropTypes.number,
  callback: PropTypes.func.isRequired,
  padronVehicular: PropTypes.number,
  message: PropTypes.string,
};

WidgetPlaca.defaultProps = {
  vehiculoId: null,
  padronVehicular: null,
  message: null,
};

export default WidgetPlaca;
